export default "__VITE_ASSET__R6xIwCvZ__"